export class TransferFile {

  corrId: string;
  downloaded: boolean = false;
  expired: boolean;
  id: string;
  name: string;
  path: string;
  progress: number = 0; // percentage 0 to 100
  size: number = 0;
  status: string = 'pending';
  type: string;

  static statusCodes = {
    'pending': 0,
    'running': 1,
    'completed': 2,
    'failed': 3,
    'canceled': 4
  }

  public constructor(init?:Partial<TransferFile>) {
    Object.assign(this, init);
  }

  static fromRecord(record): TransferFile {
    let file = new TransferFile()
    file.corrId = record.corrid || record.dh_corrid || record.corrID;
    file.downloaded = (record.download_status === 'Downloaded');
    let expired = record.expired != null ? record.expired : record.dh_expired;
    file.expired = (expired == true);
    file.id = ''+(record.id || record.dh_id);
    file.name = record.filename || record.dh_filename || record.dhFilename;
    file.path = record.source_relative_path || record.dh_source_relative_path || record.dhSourceRelativePath;
    file.size = record.filesize || record.dh_filesize || record.dhFilesize;
    let status = record.dh_status != null ? record.dh_status : (record.dh_delivery_status != null ? record.dh_delivery_status : record.dhDeliveryStatus);
    file.status = this.getStatusFromCode(status);
    return file;
  }

  static getStatusFromCode(code): string {
    for (let status in this.statusCodes) {
      let statusCode = this.statusCodes[status];
      if (code == statusCode) {
        return status;
      }
    }
    return null;
  }
}


// WEBPACK FOOTER //
// ./src/app/transfers/transfer-file.model.ts